const SimpleLightbox = require('simple-lightbox');

function handleLink(e) {
    const container = document.createElement('div');
    // const imgObj = document.createElement('img');

    // Get attributes
    const logo = e.currentTarget.getAttribute('data-logo');
    const header = e.currentTarget.getAttribute('data-header');
    const name = e.currentTarget.getAttribute('data-name');
    const userLocale = e.currentTarget.getAttribute('data-user-locale');
    let userLocaleFixed = userLocale;
    const regions = e.currentTarget.getAttribute('data-regions').split(' ');
    const { href } = e.currentTarget;

    // Change EU Locale to DE
    if (userLocale === 'EU') {
        userLocaleFixed = 'DE';
    }

    // Debug
    console.log(userLocale);
    console.log(name);
    console.log(logo);
    console.log(header);
    console.log(regions);

    // Check if user locale is in regions and if so go to brand page
    if (regions.includes(userLocaleFixed)) {
        // Follow brand link
        window.location.href = href;
        return true;
    }

    container.className = 'brands-region-popup-wrapper fade-in';
    container.style.position = 'relative';
    // container.style.overflow = 'hidden';
    // container.style.paddingTop = '52.25%';
    container.style.width = '800px';
    container.style.maxWidth = '100%';

    // imgObj.style.position = 'absolute';
    // imgObj.style.top = 0;
    // imgObj.style.left = 0;
    // imgObj.style.width = '100%';
    // imgObj.style.height = '100%';
    // imgObj.style.border = 'none';

    // imgObj.setAttribute('src', e.currentTarget.href);

    // container.appendChild(imgObj);
    let template = `<div class="brands-regions-popup-header" style="background-image: url('/${header}');">`;
    template += '<img class="logo mt-5 ml-5" src="/images/Quiet-Mark-Logo---Label---RGB.png" alt="">';
    template += '</div>';
    template += '<div class="brands-region-popup-inner">';
    template += `<div class="logo"><img class="logo" src="${logo}" /></div>`;
    template += '';
    template += '<div class="text">';
    template += `${name} do not currently have any Quiet Mark certified products in your location.`;
    template += '<div class="buttons mt-5">';
    if (userLocale === 'GB') {
        template += `<a class="btn text-black btn--auto btn--blue-outline close-popup">Go back to Quiet Mark ${userLocale} site</a>`;
        if (regions.includes('US')) {
            template += `<a href="/set_language/US?next=${href}" class="btn text-black btn--auto btn--blue-outline">Switch to Quiet Mark US site</a>`;
        }
        if (regions.includes('DE')) {
            template += `<a href="/set_language/EU?next=${href}" class="btn text-black btn--auto btn--blue-outline">Switch to Quiet Mark EU site</a>`;
        }
    }
    if (userLocale === 'US') {
        template += `<a class="btn text-black btn--auto btn--blue-outline close-popup">Go back to Quiet Mark ${userLocale} site</a>`;
        if (regions.includes('GB')) {
            template += `<a href="/set_language/GB?next=${href}" class="btn text-black btn--auto btn--blue-outline">Switch to Quiet Mark GB site</a>`;
        }
        if (regions.includes('DE')) {
            template += `<a href="/set_language/EU?next=${href}" class="btn text-black btn--auto btn--blue-outline">Switch to Quiet Mark EU site</a>`;
        }
    }
    if (userLocale === 'EU') {
        template += `<a class="btn text-black btn--auto btn--blue-outline close-popup">Go back to Quiet Mark ${userLocale} site</a>`;
        if (regions.includes('GB')) {
            template += `<a href="/set_language/GB?next=${href}" class="btn text-black btn--auto btn--blue-outline">Switch to Quiet Mark GB site</a>`;
        }
        if (regions.includes('US')) {
            template += `<a href="/set_language/US?next=${href}" class="btn text-black btn--auto btn--blue-outline">Switch to Quiet Mark US site</a>`;
        }
    }
    template += '</div>';
    template += '</div>';
    template += '</div>';
    container.innerHTML = template;

    e.preventDefault();
    e.stopPropagation();

    const lb = SimpleLightbox.open({
        content: container,
        elementClass: 'js-lightbox',
        closeBtnClass: 'brands-region-popup-close',
    });

    document.querySelectorAll('.close-popup').forEach((link) => {
        console.log(lb);
        link.addEventListener('click', () => { lb.destroy(); });
        link.addEventListener('tap', () => { lb.destroy(); });
    });

    return true;
}

document.querySelectorAll('.js-all-brands-popup').forEach((link) => {
    link.addEventListener('click', handleLink);
    link.addEventListener('tap', handleLink);
});
